import { useWatch } from 'react-hook-form';
import { Dropdown } from '@monash/portal-react';

// A wrapper for dropdown which supplies category options that have not already been selected.
// The logic is encapsulated here in its own component to limit re-renders to only category dropdowns
// whenever categories are selected.
const CategoriesDropdown = ({ index, dropdownOptions, ...dropdownProps }) => {
  const watchedCategories = useWatch({ name: `categories` });

  const availableCategoryOptions = dropdownOptions.filter((category) => {
    // include the currently selected category as an option
    if (category.value === watchedCategories[index].id) return true;

    // else, only include categories that haven't already been selected in another card
    return !watchedCategories.some((selectedCategoryObj) => {
      return category.value === selectedCategoryObj.id;
    });
  });

  return <Dropdown data={availableCategoryOptions} {...dropdownProps} />;
};

export default CategoriesDropdown;
